module.exports = __webpack_public_path__ + "img/foto_beneden-border.7ee8e9e8.jpg";